// extracted by mini-css-extract-plugin
export default {"cardInfor":"accessibility_cardInfor__PC6kb","body":"accessibility_body__T5pxf","txt":"accessibility_txt__Q5p42"};